const re = /^\d{10}$/;

export const validatePhone = (phone: string): boolean => re.test(String(phone));
